// Module
var code = "<div data-bind=\"geDropDownList: selectedSavedSearchId, source: savedSearches, selectedValue: selectedSavedSearch, \r\n    componentId: dropdownListId, properties: { placeHolder: 'Select Grid Filter'}\"> </div> ";
// Exports
export default code;